module.exports = __webpack_public_path__ + "images/liinilaevad/favicon-32x32.png";